<template>
  <div>
    <MobileHeader active="welfare"></MobileHeader>
    <el-row>
      <h1>公益事业</h1>
    </el-row>
    <div class="swiper-container">
      <el-row >
        <img src="../../assets/imgs/welfare/welfare_bg.jpg" style="display: inline-block; width: 100%; max-width: 100%; height: 150px;">
        <i class="el-icon-caret-top" style="font-size: 90px;margin-top: -60px;color: white;"></i>        <!--<div class="triangle"></div>-->
      </el-row>
      <el-row class="spacing-up"></el-row>
    </div>
    <div v-for="item in list" v-bind:key="item.id">
      <el-row class="welfare-img">
        <el-col :span="24">
          <el-image :src="item.image" ></el-image>
          <!-- <div class="triangle"></div> -->
        </el-col>
      </el-row>
      <div style="margin-left:10px;margin-right:10px;" @click="toDetail(item.id)">
        <h3 class="news-title">{{item.title}}</h3>
        <p
          class="news-summary"
          style="text-align: justify;text-justify: inter-ideograph;"
        >{{item.summary}}</p>
      </div>
    </div>
    <MobileFooter></MobileFooter>
  </div>
</template>

<script>
import MobileHeader from "../../components/MobileHeader";
import { newsApi } from "../../api/news-api";
import MobileFooter from "../../components/MobileFooter";
export default {
  name: "MobileWelfare",
  components: { MobileFooter,MobileHeader },
  data() {
    return {
      page: 1,
      limit: 50,
      totalPage: 1,
      list: [],
      finished: false,
    };
  },
  mounted() {
    this.listNews();
  },
  methods: {
    listNews() {
      newsApi
        .list({
          type: 4,
          status: 1,
          page: this.page,
          limit: this.limit,
        })
        .then((res) => {
          console.log(res);
          if (res.code === 200) {
            this.totalPage = res.page.totalPage;
            if (this.page >= res.page.totalPage) {
              this.finished = true;
            }
            this.list = res.page.list;
          }
        });
    },
    toDetail(id) {
      this.$router.push({
        path: `/detail/${id}`,
        query: {
          active: "welfare",
        },
      });
    },
  },
};
</script>

<style scoped>
.swiper-container {
  width: 100%;
  padding-top: 10px;
  text-align: center;
  font-size: 15pt;
}
.banner {
  height: 150px;
  width: 100%;
  background: url("../../assets/imgs/welfare/welfare_bg.jpg") no-repeat;
  background-size: 100% 100%;
}
.spacing-up {
  text-align: left;
  margin-bottom: 20px;
  padding-left: 5%;
  /* padding-top: 3%; */
  font-size: 15pt;
}
.triangle {
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid white;
  margin-top: 25%;
  margin-left: 48%;
}
.welfare-img {
  width: 100%;
  height: auto;
}
</style>